import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
// src/components/HelpBlock/HelpBlock.tsx
const helpVariants = cva(["tw:m-0", "tw:text-xs"], {
	defaultVariants: { state: "default" },
	variants: { state: {
		default: ["tw:text-muted-foreground"],
		warning: ["tw:text-warning"]
	} }
});
const HelpBlock = ({ children, className, state = "default", ...rest }) => {
	if (!children) return null;
	return /* @__PURE__ */ jsx("p", {
		...rest,
		className: helpVariants({
			state,
			className
		}),
		children
	});
};
export { HelpBlock };

//# sourceMappingURL=HelpBlock.js.map